import React, { useContext } from 'react';
import { AuthContext } from '../context/auth';

function Barra() {

  let op = require('../../src/modulos/datos');
  const { user } = useContext(AuthContext);


  return (

    user && (

      <div className="col-md-2 azulGradiant" style={{ height: "100%", padding: 0, color:"#fff" }}>
        <div className="col-md-12" style={{ height: "45%" }}>
          <img src={op.imagenes + '/imagen?img=logo.png'} style={{ width: "100%", height:"80%" }} alt="" />
        </div>
        <div className="col-md-12" style={{ height: "45%" }}>
          <img src={op.imagenes + '/imagen?img=Logopsiap.png'} style={{ width: "100%", height:"80%" }} alt="" />
        </div>
        <footer className="col-md-12" style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          color: 'white',
          fontSize: "10px",
          height: "10%"
        }} >
          <strong>Copyright © 2014-2019 <a href="#" style={{ color: 'white' }}>Sygreca</a>.</strong>
             Todos los Derechos Reservados.
          </footer>

      </div>

    )


  );
}


export default Barra;
